import * as React from 'react';
import { getBaseUrl } from '../../../utilities';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import { Media, MediaContextProvider } from '../../../theme/media';
import { ArrowRightIcon } from '../SideMenu/icons';

const NEAR_BLACK = '#171717';
const SIDEBAR_WIDTH = 272;

const SideAside = styled.aside`
  flex: 0 0 ${rem(SIDEBAR_WIDTH)};
  align-self: flex-start;
`;

const Wrapper = styled.ul`
  margin: 0;
  padding: ${rem(8)} 0;
  list-style: none;
  width: ${rem(SIDEBAR_WIDTH)};
  background: ${({ theme }) => theme.color.white};
  border: ${rem(1)} solid #e0e0e0;
`;

const Item = styled.li`
  list-style: none;
  &.hidden {
    display: none;
  }
`;

const rowStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${rem(8)};
  color: ${NEAR_BLACK};
  padding: ${rem(12)};
  font-size: ${rem(15)};
  line-height: ${rem(24)};
  text-decoration: none;

  > span {
    min-width: 0;
    /* Wrap long labels (e.g. a shop name in the /predajne sidebar) rather than
       letting a too-long word overflow the fixed-width column to the right. */
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .side-arrow {
    width: ${rem(16)};
    height: ${rem(16)};
    flex: 0 0 auto;
    color: ${NEAR_BLACK};
  }
`;

const ItemLink = styled(Link)`
  ${rowStyles};
  font-weight: 400;
  &:hover {
    background: #f7f7f7;
    text-decoration: none;
  }
`;

const ItemCurrent = styled(Link)`
  ${rowStyles};
  font-weight: 600;
  padding: ${rem(12)} ${rem(8)} ${rem(12)} ${rem(12)};
  background: ${({ theme }) => theme.color.secondary};
  &:hover {
    text-decoration: none;
  }
`;

interface SidebarContainerProps {
  items: any;
  staticItems?: any;
}

const itemTo = (url: string) =>
  getBaseUrl(
    url === 'pre-skolske-zariadenia/skolsky-nabytok'
      ? 'nabytok-a-vybavenie-skol'
      : url,
  );

const SidebarContainer = (props: SidebarContainerProps) => {
  const { items, staticItems } = props;

  return (
    <MediaContextProvider>
      <Media greaterThanOrEqual="lg">
        <SideAside>
          <Wrapper>
            {items?.length
              ? items.map((item, i) => (
                  <Item key={i} className={item.active ? 'active' : ''}>
                    {item.active ? (
                      <ItemCurrent to={itemTo(item.url)}>
                        <span>{item.text}</span>
                      </ItemCurrent>
                    ) : (
                      <ItemLink to={itemTo(item.url)}>
                        <span>{item.text}</span>
                        <ArrowRightIcon className="side-arrow" />
                      </ItemLink>
                    )}
                  </Item>
                ))
              : null}

            {staticItems?.length ? (
              staticItems.map((item, i) => (
                <Item key={`static-${i}`}>
                  <ItemLink to={item.url}>
                    <span>{item.text}</span>
                    <ArrowRightIcon className="side-arrow" />
                  </ItemLink>
                </Item>
              ))
            ) : (
              <></>
            )}
          </Wrapper>
        </SideAside>
      </Media>
    </MediaContextProvider>
  );
};

export default SidebarContainer;
